<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import axios from 'axios'
import store from './store'
window.axios = axios
export default {
  name: 'App',
  created () {
    this.getToken()
    store.dispatch('getName')
  },
  methods: {
    getToken () {
      var token = localStorage.getItem('auth_token')
      if (token !== null) store.commit('token', token)
    }
  }
}
console.log('ENV Variables: ')
console.log(process.env)
</script>

<style>
  @import './assets/css/bootstrap-dark.min.css';
  @import './assets/css/app-dark.min.css';
  @import './assets/css/icons.min.css';
  @import 'animate.css/animate.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue